import { useEffect, useState } from "react";

export default function useDetectUserAgent() {
  const [windowsPlatformClassname, setWindowsPlatformClassname] = useState("");

  useEffect(() => {
    const platform =
      window.navigator?.userAgentData?.platform || window.navigator.platform;

    const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
    if (windowsPlatforms.indexOf(platform) !== -1) {
      setWindowsPlatformClassname("mega-menu__items--windows");
    }
  }, []);

  return windowsPlatformClassname;
}
